// @flow

import React from 'react';
import type moment from 'moment';
import styler from 'react-styling';
import { Grid, Row, Col } from 'react-bootstrap/lib';
import radium from 'radium';

import breakpoints from '../../../css/breakpoints';

function _createStyle(theme: string) {
  return styler `
    Container
      background-color: ${theme === 'dark' ? '#0C1428' : '#ECECEC'}
      padding: 30px
    Text
      color: ${theme === 'dark' ? '#FFF' : '#191919'}
      &TextSmall
        font-size: 20px
        margin-right: 10px
        @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
          font-size: 2.5vw
          margin-right: 1vw
      &TextBig
        font-size: 40px
        @media screen and (max-width: ${breakpoints.SMALL_AND_BELOW}px)
          font-size: 4.5vw
  `;
}

type Props = {
  text: string,
  theme: string,
  clock?: moment,
}
const MeetingRoomHeader = (props: Props) => {
  const style = _createStyle(props.theme);
  return (
    <Grid fluid style={{ width: '100%' }}>
      <Row style={style.Container}>
        <Col xs={6}>
          <span style={style.Text.TextBig}>{props.text}</span>
          <span className="text-right" style={style.Text.TextBig}>{''}</span>
        </Col>
        {props.clock ?
          <Col xs={6} className="text-right">
            <span style={style.Text.TextSmall}>{props.clock.format('dddd D. MMMM')}</span>
            <span style={style.Text.TextBig}>{props.clock.format('HH:mm')}</span>
          </Col> : null}
      </Row>
    </Grid>
  );
};

export default radium(MeetingRoomHeader);



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingRoomHeader.js